import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Lightning, Crown } from "@phosphor-icons/react";

export default function QuotaBadge({ variant = "compact" }) {
  const { user, isAdmin } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!user) return;
    let alive = true;
    const load = () => {
      api.get("/auth/quota").then((r) => alive && setData(r.data)).catch(() => {});
    };
    load();
    const t = setInterval(load, 30000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, [user]);

  if (!user || !data) return null;
  if (data.unlimited) {
    if (variant === "banner") {
      return (
        <div className="inline-flex items-center gap-2 px-3 py-1.5 border border-blue-200 bg-blue-50 text-blue-600 rounded-full" data-testid="quota-unlimited">
          <Crown size={12} weight="fill" />
          <span className="text-[10px] font-semibold uppercase tracking-wider">
            {isAdmin ? "Admin · Unlimited" : "Premium · Unlimited"}
          </span>
        </div>
      );
    }
    return null;
  }

  const exhausted = data.remaining === 0;
  return (
    <div
      className={`inline-flex items-center gap-2 px-3 py-1.5 border rounded-full ${
        exhausted ? "border-red-200 bg-red-50" : "border-slate-200 bg-slate-50"
      }`}
      data-testid="quota-badge"
    >
      <Lightning size={12} weight={exhausted ? "fill" : "regular"} className={exhausted ? "text-red-500" : "text-blue-600"} />
      <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-600">
        {data.used}/{data.limit} today
      </span>
      {exhausted && variant === "banner" && (
        <Link
          to="/profile#upgrade"
          className="text-[10px] font-semibold uppercase tracking-wider text-blue-600 hover:underline ml-1"
          data-testid="quota-upgrade-link"
        >
          Upgrade →
        </Link>
      )}
    </div>
  );
}
